import { html } from 'lit-element';

import { compareState } from '@elab/core/utils/webComponent';

import { FormElement } from './Form';

export class FieldCaption extends FormElement {
    static get properties() {
        return {
            captionType: { type: String, attribute: 'caption-type' },
        };
    }

    shouldUpdate(changedProps) {
        return [
            ['captionType'],
            ['fieldValue', 'error'],
            ['fieldValue', 'optionalLabel'],
        ].some(item => compareState(this, changedProps, ...item));
    }

    render() {
        return this.fieldValue
            ? html`
                  <span class="text">
                      <span
                          data-target="label"
                          class="${this.captionType === 'toggler'
                              ? 'toggler__label'
                              : 'form-label'}${this.isErrorDefined() ? ' form-label--error' : ''}"
                      ></span>
                      ${this.fieldValue.optionalLabel
                          ? html`
                                <span class="text--14 text--bold text--black"
                                    >&nbsp;<v-slot></v-slot
                                ></span>
                            `
                          : ''}
                  </span>
              `
            : null;
    }
}

export default () => customElements.define('e2-field-caption', FieldCaption);
